import { FAILURE, POST, SUCCESS, GET, PUT } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import { BASE_URL } from "../utils/const/base-url";
import { FORMATO_FECHA } from "../utils/const/formato-fecha";
import moment from "moment";

export async function obtenerListaBadge(combo = false, tag) {
    try {
        let data = { error: true };
        const { status, body, message, } = await fetch(
            `${BASE_URL}/badge/obtener-lista-badges`,
            {
                headers: getHeaders(false),
                method: GET,
                // body: JSON.stringify({ usuario, password }),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (status === SUCCESS) {
            data.error = false;
            data.body = body;
            if (combo === true) {
                data.body = data.body.map(item => ({
                    label: `${tag(item.descripcion)}`,
                    value: item.id,
                }));
            }
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
            data.body = null;
        }
        // console.log('data');
        // console.log(data);
        return data;
    } catch (err) {
        console.log("obtenerListaBadge err");
        console.log(err);
        return { error: true, message: err };
    }
}